import darklight from "../../../../assets/images/docs/darklight.png";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  darklight,
  ShortCutDisplay,
  React
};